<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Evolución de Evaluación de Polivalencias</h6>
                </v-card-title>
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listado" group-by="gerencia" locale="es-ar"
                        class="elevation-1" :items-per-page="500" hide-default-footer>
                        <template v-slot:group.header="{ items }">
                            <td :colspan="headers.length" class="text-xs-right" style="color: green;">
                                <strong>{{ items[0].gerencia }}</strong>
                            </td>
                        </template>
                        <!-- <template v-slot:group.header="{ items }">
                            <td class="text-xs-right" style="color: green;">
                                <strong>{{ items[0].gerencia }}</strong>
                            </td>
                        </template> -->
                        <template v-slot:group.summary="{ group, items }">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>
                            <td>
                                <h6><b> {{ subTotal(items, 'puntaje1').toFixed(2) }}</b></h6>
                            </td>
                            </th>
                            <th>
                            <td>
                                <h6><b>{{ subTotal(items, 'puntaje2').toFixed(2) }}</b></h6>
                            </td>
                            </th>
                            <th>
                            <td>
                                <h6><b>{{ subTotal(items, 'puntaje3').toFixed(2) }}</b></h6>
                            </td>
                            </th>
                        </template>
                        <template slot="body.append">
                            <tr>
                                <th>
                                    <h6><b>PROMEDIO TOTAL</b></h6>
                                </th>
                                <th>-</th>
                                <th>-</th>
                                <th>
                                    <h6><b>{{ promtotalant.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promtotalpres.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ porcentaje.toFixed(3) }}</b></h6>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>

<style scoped>
.v-data-table__group.summary {
    display: none;
}
</style>
<script>
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {

    data: (vm) => ({

        filtrocodgral: "",
        filtromes: "",
        filtroresponsable: "",
        filtroobserv: "",
        listadoequipo: [],
        date: new Date().toISOString().substr(0, 7),
        datehoy: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        listado: [],
        promtotalant: 0,
        promtotalpres: 0,
        porcentaje: 0,
        evoluciontotalant: 0,
        evoluciontotalpres: 0,
        cantidadtotal: 0,
        headers: [
            {
                text: "Gerencia",
                align: "start",
                sortable: false,
                value: "gerencia",
                width: "25%"
            },
            { text: "", value: "", width: "10%" },
            { text: "Legajo", value: "legajo", width: "10%" },
            { text: "Nombre", value: "nombre", width: "25%" },
            { text: "Polivalencia anterior", value: "puntaje1", width: "10%" },
            { text: "Polivalencia año actual", value: "puntaje2", width: "10%" },
            { text: "Evolucion", value: "puntaje3", width: "10%" },

        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        subTotal(items, column) {
            // console.warn(items, column);
            //return items.reduce((sum, item) => sum + item[column], 0);
            //return items.reduce((sum, item) => sum + parseFloat(item[column].toString().replace(',', '.')), 0);
            const total = items.reduce((sum, item) => {
                const val = item[column];
                if (val === null || val === undefined || val === '') return sum;
                const parsed = parseFloat(val.toString().replace(',', '.'));
                if (isNaN(parsed)) return sum;
                return sum + parsed;
            }, 0);
            const validItems = items.filter(item => {
                const val = item[column];
                if (val === null || val === undefined || val === '') return false;
                return !isNaN(parseFloat(val.toString().replace(',', '.')));
            });
            const average = validItems.length > 0 ? total / validItems.length : 0;
            return average;
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month] = date.split("-");
            return `${month}/${year}`;
        },

        cargarListados() {
            this.vaciarModels();

            let self = this;

            axios
                .get("/RRHH/ListadoEvolucionPoliv?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.promtotalant = 0;
                    self.promtotalpres = 0;
                    self.porcentaje = 0;
                    self.evoluciontotalant = 0;
                    self.evoluciontotalpres = 0;
                    self.cantidadtotal = 0;

                    // Filtrar: solo mostrar los que tienen polivalencia en ambos años
                    self.listado = response.data.filter(item => {
                        const p1 = item.puntaje1;
                        const p2 = item.puntaje2;
                        return p1 !== null && p1 !== undefined && p1 !== '' 
                            && p2 !== null && p2 !== undefined && p2 !== '';
                    });

                    for (let i = 0; i < self.listado.length; i++) {
                        const p1 = parseFloat(self.listado[i].puntaje1) || 0;
                        const p2 = parseFloat(self.listado[i].puntaje2) || 0;
                        self.evoluciontotalant += p1;
                        self.evoluciontotalpres += p2;
                        self.cantidadtotal += 1;
                    }
                    self.promtotalant = self.cantidadtotal > 0 ? self.evoluciontotalant / self.cantidadtotal : 0;
                    self.promtotalpres = self.cantidadtotal > 0 ? self.evoluciontotalpres / self.cantidadtotal : 0;
                    self.porcentaje = self.promtotalant > 0 ? self.promtotalpres / self.promtotalant : 0;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>